// extracted by mini-css-extract-plugin
export default {"card-style":"style_card-style__gNEgX","container":"style_container__4mj2L","right":"style_right__eX6ex","left":"style_left__P4DNS","center":"style_center__XJmVj"};